// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"623":"e187ec61","787":"c8de6e26"}[chunkId] + ".chunk.js";
};